/* eslint-disable */
export enum DefaultSettingActionTypes {
  SET_CUSTOMER = "@@DefaultSettings/SET_CUSTOMER",
  SET_DEVICE_HARDWARE_ID = "@@DefaultSettings/SET_DEVICE_HARDWARE_ID",
  REPORTS_CHANGED = "@@DefaultSettings/REPORTS_CHANGED"
}
